// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body {\r\n\tbackground-color: rgb(238, 238, 238);\r\n}\r\n\r\n", "",{"version":3,"sources":["webpack://wwwroot/app/components/unit-detail/unit-detail.component.css"],"names":[],"mappings":"AAAA;CACC,oCAAoC;AACrC","sourcesContent":["body {\r\n\tbackground-color: rgb(238, 238, 238);\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
